(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["email-signup"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('newsletter-signup')) {
    customElements.define('newsletter-signup', class extends HTMLElement {
      connectedCallback() {
        const form = this.querySelector('form');
        const status = this.querySelector('[data-newsletter-success], [data-newsletter-error]');
        if (status instanceof HTMLElement) requestAnimationFrame(() => status.focus());
        form?.addEventListener('submit', (event) => {
          if (!(form instanceof HTMLFormElement)) return;
          const email = form.querySelector('[data-newsletter-email]');
          const submit = form.querySelector('[data-newsletter-submit]');
          if (email instanceof HTMLInputElement && !email.validity.valid) {
            event.preventDefault();
            email.setCustomValidity('Enter a valid email address to join the list.');
            email.reportValidity();
            email.addEventListener('input', () => email.setCustomValidity(''), { once: true });
            return;
          }
          if (submit instanceof HTMLButtonElement) { submit.disabled = true; submit.setAttribute('aria-disabled', 'true'); }
          form.setAttribute('aria-busy', 'true');
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
